import React, { Fragment, useContext, useEffect, useState } from 'react'
import ListItem from 'Molecules/List/ListItem'
import List from 'Molecules/List'
import ListItemText from 'Molecules/List/ListItemText'
import Divider from 'Atoms/Divider'
import ListItemIcon from 'Molecules/List/ListItemIcon'

import { ThemeContext } from 'Contexts/ThemeContext'
import { VehicleContext } from 'Contexts/VehicleContext'
import { RemoveUserVehicle, AddUserVehicle, getPropperUrl } from 'Contexts/VehicleContext/CoreVehicleRequests'

import styles from './YourVehicles.module.scss'
import useSegment from '../../../../Hooks/useSegment/useSegment'
import { createFitmentRemovedSegmentEvent } from '../../../../Utilities/Instrumentation/Fitment/fitmentSegmentEvents'

const YourVehicles = ({ userGuid, services, showAllVehicles, ...props }) => {
    const { context: vehicleState, SelectCustomerProject, ClearSelectedVehicle, UpdateCustomerVehicles } = useContext(VehicleContext)
    const { setIsLoading } = useContext(ThemeContext)
    const [clearSelected, setClearSelected] = useState(false)
    const { sendCustomSegmentTrackEvent } = useSegment();

    useEffect(() => {
        if (clearSelected) {
            let redirectUrl = '/'
            if (window.SMI && SMI.getPageTypeClass() === "ProductPageTypePageContainer") {
                redirectUrl = window.location.href
            }

            ClearSelectedVehicle(redirectUrl)
            setClearSelected(false)
        }
    }, [clearSelected])
    var customerVehicles = getOrderedCustomerVehicles(
        vehicleState?.customerVehicles,
        vehicleState.selectedVehicle
    )


    if (!userGuid || !services?.customerVehicles?.url) return false
    if (customerVehicles && customerVehicles.length > 0) {
        if (!showAllVehicles && customerVehicles?.length > 3) {
            customerVehicles = customerVehicles.slice(0, 3)
        }
        let selectedVehicle = vehicleState.selectedVehicle
        return (
            <List
                itemLayout={'vertical'}
                className={styles.vehicleListWrapper}
                component={'div'}
            >
                {customerVehicles.map((item, index) => {
                    let shopUrl = window.location
                    let displayName
                    let isSelected = false
                    if (item.raceTypeId) {
                        shopUrl = getPropperUrl(item);
                        displayName = item.raceName
                        if (selectedVehicle.raceTypeId === item.raceTypeId) {
                            isSelected = true
                        }
                    } else if (item.modelId) {
                        shopUrl = getPropperUrl(item);
                        displayName = `${item.year} ${item.make} ${item.model}`
                        if (selectedVehicle.projectId === item.projectId) {
                            isSelected = true
                        }
                    }
                    return (
                        <Fragment key={"garageItem" + displayName}>
                            <ListItem
                                className={styles.vehicleContainer}
                                component={'div'}
                                underline
                                onClick={async () => {
                                    setIsLoading(true)
                                    let response = AddUserVehicle(userGuid, services?.customerVehicles?.url, item.year, item.makeId, item.modelId, item.raceTypeId)
                                    UpdateCustomerVehicles(response?.addNewProjectToGarage?.projects)
                                    SelectCustomerProject(item.projectId, shopUrl)
                                }}
                                data-testid={displayName}
                            >
                                {isSelected ? (
                                    <ListItemIcon
                                        className={
                                            styles.selectedVehicleIcon
                                        }
                                        icon={'savedCheckmark'}
                                        tone={'normal'}
                                        intent={'positive'}
                                        size={1}
                                    />
                                ) : (
                                    <div className={styles.space} />
                                )}
                                <ListItemText
                                    className={styles.vehicleTitleText}
                                    primaryTypographyProps={{
                                        size: 0.875,
                                        underlineHover: true,
                                        font: 'bold',
                                        className: styles.vehiclePrimaryText
                                    }}
                                    primary={displayName}
                                />
                                <ListItemIcon
                                    icon={'trash'}
                                    tone={'normal'}
                                    size={1}
                                    className={styles.vehicleTrash}
                                    data-testid={displayName + '-trash'}
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        const segmentEvent = createFitmentRemovedSegmentEvent(item.makeId, item.make, item.modelId, item.model, item.year, item.raceTypeId, item.raceName)
                                        sendCustomSegmentTrackEvent(segmentEvent)

                                        var response = await RemoveUserVehicle(
                                            userGuid,
                                            item.projectId,
                                            services?.customerVehicles?.url
                                        )

                                        if (response) {
                                            UpdateCustomerVehicles(response.removeProjectFromGarage.projects)
                                            setClearSelected(isSelected)
                                        }
                                    }}
                                />
                            </ListItem>

                            <Divider
                                className={styles.vehicleDivider}
                                tone={'superfluous'}
                            />
                        </Fragment>
                    )
                })}
            </List>
        )
    }
    return false
}

function getOrderedCustomerVehicles(customerVehicles, selectedVehicle) {
    if (!selectedVehicle) return customerVehicles

    if (!customerVehicles || customerVehicles.length == 0) return null

    let selectedVehicleData = customerVehicles.find(
        (x) => x.projectId === selectedVehicle.projectId
    )

    if (!selectedVehicleData) return customerVehicles

    let filteredVechiles = customerVehicles.filter(
        (x) => x.projectId !== selectedVehicle.projectId
    )

    return [selectedVehicleData, ...filteredVechiles]
}
export default YourVehicles
